<!--
 * @Description: 
 * @Date: 2020-09-25 14:58:52
 * @LastEditors: jml
-->
<template>
  <van-dialog
    class="custom-dialog"
    :class="{'hide-footer':hideConfirm&&!showCancel}"
    v-model="show"
    :show-confirm-button="!hideConfirm"
    :show-cancel-button="showCancel"
    :confirm-button-text="confirmText"
    :cancel-button-text="cancelText"
  >
    <template slot="title">
      <van-icon name="close" class="close-icon-btn" @click="show=false" />
      <div v-html="title"></div>
    </template>
    <template v-if="isText">
      <div>{{content}}</div>
    </template>
    <template v-if="isHtml">
      <div v-html="content"></div>
    </template>
    <template v-if="!isText && !isHtml">
      <component :is="content" :data="params" :callback="callback"></component>
    </template>
  </van-dialog>
</template>

<script>
export default {
  data() {
    return {
      show: true
    };
  },
  props: {
    content: {},
    title: {},
    hideConfirm: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: false
    },
    confirmText: {
      type: String,
      default: '确认'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    isText: {
      type: Boolean,
      default: false
    },
    isHtml: {
      type: Boolean,
      default: false
    },
    params: {
      type: Object,
      default: () => {
        return {};
      }
    },
    callback: {}
  }
};
</script>
<style lang="scss">
.custom-dialog {
  border-radius: 0.21rem;
  width: 8.72rem;
  padding-bottom: 0.43rem;
  overflow: initial;
  .van-dialog__header {
    padding-top: 0;
    position: relative;
    .close-icon-btn {
      position: absolute;
      right: 0;
      top: -1.2rem;
      font-size: 0.85rem;
      color: #fff;
    }
    & > div {
      padding-top: 0.43rem;
      padding-left: 1.16rem;
      padding-right: 1.16rem;
      padding-bottom: 0.43rem;
      font-size: 0.32rem;
      color: #9ea0aa;
      line-height: 0.48rem;
      &:empty {
        padding-top: 0;
      }
    }
  }
  .van-dialog__content {
    padding-left: 0.43rem;
    padding-right: 0.43rem;
  }
  .van-dialog__footer {
    padding-left: 0.43rem;
    padding-right: 0.43rem;
    margin-top: 1rem;
    .van-button {
      width: 7.87rem;
      height: 1.28rem;
      // background: #3667ec;
      border-radius: 0.11rem;
      font-size: 0.48rem;
      font-weight: 500;
      color: #fff;
      & + .van-button {
        margin-left: 0.4rem;
      }
    }
    .van-dialog__cancel {
      background: none;
      border: 2px solid #3667ec;
      color: #3667ec;
    }
  }
  &.hide-footer {
    .van-dialog__footer {
      display: none;
    }
  }
}
</style>